import React from 'react';

const Card = ({ children, customClasses }) => {
    const extraClasses = customClasses || '';   
    return (
        <div className={'bg-card text-card-foreground rounded-lg shadow-lg w-full ' + extraClasses}>
            {children}
        </div>
    );
};

export default Card;
